import { DecorationEntryDto } from './decoration-entry-dto';
import { InMoldLabelDto } from './in-mold-label-dto';

export class InMoldLabelEntryDto extends DecorationEntryDto {
    underlyingComponent!: InMoldLabelDto;
    isAdhesiveUsed: boolean | null = null;
    removabilityConditionId = -1;
}
